const pocket = (id, name, capacityMl, maxDimensionMm, baseAccessSeconds) => ({
    id, name, capacityMl, maxDimensionMm, baseAccessSeconds, fillPenaltySeconds: 1.2,
    burialPenaltySeconds: 2, quickAccessEligible: true,
});
export const CLOTHING_ITEM_DEFINITIONS = [{
        id: 'clothing.jeans_basic', name: 'BLUE JEANS', description: 'Durable blue denim trousers with five physical pockets.',
        category: 'CLOTHING', tags: ['FABRIC'], stackLimit: 1, unitMassGrams: 620, volumeMl: 1600, longestDimensionMm: 350,
        iconKey: 'jeans', worldAssetId: 'cloth_bundle', scarcity: 'COMMON', sortOrder: 80,
        wearable: { equipmentSlot: 'LEGS', visualId: 'jeans_basic', insulationClo: 0.3, closures: [], pockets: [
                pocket('LEFT_FRONT', 'LEFT FRONT POCKET', 850, 220, 0.7),
                pocket('RIGHT_FRONT', 'RIGHT FRONT POCKET', 850, 220, 0.7),
                pocket('LEFT_REAR', 'LEFT REAR POCKET', 550, 170, 1.0),
                pocket('RIGHT_REAR', 'RIGHT REAR POCKET', 550, 170, 1.0),
                { ...pocket('WATCH', 'WATCH POCKET', 120, 120, 5), obstructedByPocketId: 'RIGHT_FRONT', obstructionPenaltySeconds: 4 },
            ] },
    }];
export const PHYSICAL_STARTER_LOADOUT = Object.freeze({
    garmentDefinitionId: 'clothing.jeans_basic', flashlightDefinitionId: 'tool.flashlight_aa_basic',
    batteryDefinitionId: 'electronics.battery_aa', flashlightPocketId: 'RIGHT_FRONT', sparePocketId: 'LEFT_FRONT', spareCells: 2,
});
